import { Component, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { State } from 'src/app/reducers';
import { User } from 'src/app/store/auth/auth.models';

export interface Widget {
  name: string;
  label: string;
  url: string;
  icon?: string;
  description: string;
  enabled: boolean;
}
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss'],
})
export class DashboardComponent implements OnDestroy {
  destroyer$: Subject<any> = new Subject();
  currentUser: User = null;

  dashboardWidgets: Widget[] = [
    {
      name: 'userPortal',
      label: 'profile',
      url: '/user-portal/profile',
      icon: 'account_circle',
      enabled: true,
      description: 'Learn everything about yourself',
    },
    {
      name: 'assessmentPortal',
      label: 'assessments',
      url: '/assessments',
      enabled: true,
      icon: 'assignment',
      description: 'Please take an assessment to plan your bright future',
    },
    {
      name: 'resumePortal',
      label: 'resumes',
      url: '/resume-portal/all-resumes',
      icon: 'menu_book',
      enabled: false,
      description:
        'COMING SOON',
    },
    {
      name: 'goalPortal',
      label: 'goals',
      url: '/goal-portal/goals-list',
      icon: 'emoji_events',
      enabled: true,
      description: 'Plan your goals for better outcome and results',
    },
    {
      name: 'resourcesPortal',
      label: 'resources',
      url: 'http://kamyka.1apisolution.com/resources/#tips',
      icon: 'source',
      enabled: true,
      description:
        'Check out all resources that we have to help you accomplish your goals and objectives',
    },
  ];
  constructor(private store: Store<State>, private router: Router) {
    this.store.select(state => state.auth.authenticatedUser).pipe(takeUntil(this.destroyer$)).subscribe((user: User) => this.currentUser = user);
  }

  getUserFullName(): string {
    return this.currentUser ? `${this.currentUser.given_name} ${this.currentUser.family_name}`: '';
  }

  ngOnDestroy(): void {
    this.destroyer$.next(true);
    this.destroyer$.complete();
  }

  goTo(widget: Widget): void {
    if (widget.enabled) {
      if (widget.url.startsWith('http')) {
        window.open(widget.url, '_blank');
      } else {
        this.router.navigate([widget.url]);
      }
    }
  }
}
